import React from 'react';
import { ChevronUp } from 'tabler-icons-react';

export function HighPriorityIcon() {
  return <ChevronUp color="#e31c3d" size={20} />;
}
